import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Reset = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="129.06"
        height="120.68"
        viewBox="0 0 129.06 120.68"
        fill="currentColor"
    >
        <path d="M99.51,99.52c-1.72-1.74-4.49-1.86-6.36-.29-21.5,18.41-53.85,15.9-72.26-5.61C2.49,72.11,5,39.76,26.5,21.36c19.94-17.07,49.56-16.31,68.6,1.76,.51,.46,.54,1.24,.08,1.75-.02,.02-.04,.04-.06,.06l-11.21,11.21c-1.97,1.99-1.96,5.19,.03,7.16,.67,.67,1.52,1.13,2.45,1.34l36.5,6.45c2.71,.63,5.42-1.07,6.05-3.78,.17-.75,.17-1.52,0-2.27l-6.6-36.24c-.62-2.73-3.33-4.44-6.06-3.82-.93,.21-1.77,.68-2.45,1.34l-10.2,10.2c-.47,.49-1.25,.51-1.75,.04,0,0,0,0-.01-.01C77.68-6.37,39.49-5.36,16.56,18.82c-22.93,24.18-21.92,62.37,2.26,85.3,22.3,21.15,56.94,22.15,80.43,2.33,1.98-1.68,2.22-4.64,.55-6.62-.09-.1-.18-.21-.28-.3h0Z" />
        <circle cx="59.46" cy="60.17" r="13.8" />
    </svg>
);

Reset.propTypes = propTypes;
Reset.defaultProps = defaultProps;

export default Reset;
